module.exports = __webpack_public_path__ + "media/images/memes/shut-up-meme-fd1fc9fc4f837e191fe48d9b0e1992b8.gif";